import axios from 'axios'

// config
import baseUrl from '../config'

export const generateEmp501File = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/sef/generate-emp501`,
    data
  })
}
